import { useAppSelector } from "../store/configureStore";
import { useLocation } from "react-router-dom";
import useReadOnlyPreset from "./useReadOnlyPreset";
import useHQmanager from "./useHQmanager";

// Per-row decline / actions columns.
// - HQ only needs them on the Approve preset.
// - Picker / admin see them everywhere except the read-only Original / All.
export default function useShowRowActions(): boolean {
  const { search } = useLocation();
  const preset = new URLSearchParams(search).get("preset");
  const { user } = useAppSelector((state) => state.account);
  const isHQ = useHQmanager(user);
  const readOnly = useReadOnlyPreset();

  if (isHQ) return preset === "approve";
  return !readOnly;
}
